import { ELocalStorageKeys } from 'constants/enums';
import { UserDetails } from 'pages/Login/Login.types';

import { localStorageUtil } from './localStorageUtil';

export const getPublisherIdByPortalId = (portalId: string): string | undefined => {
  const portals = localStorageUtil.get<UserDetails>(ELocalStorageKeys.USER_DETAILS)?.portals;
  const store = portals?.find(p => p.portalId === portalId)?.stores?.[0];
  return store?.storeId;
};

export const SLUG_SANITIZE_REGEX = /[^\p{L}0-9]+|(?<=-)-+|^-+|-+$/gu;

export const sanitizeSlug = (str: string) => {
  return str.toLowerCase().replace(SLUG_SANITIZE_REGEX, (match, offset, string) => 
    offset === string.length - match.length ? '' : '-'
  );
};